/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import { modelTypesById } from '#src/js/constants/models/modelTypes/index.js';
import withCustomHandleSubmit from '#components/pages/Models/Model/support/Router/withSectionFunctionality/withCustomHandleSubmit/index.js';
import { acceptAllProposedFields, rejectAllProposedFields } from '#actions/models/aiReview.js';
import ModelPagerSidebar from './ModelPageSidebar.jsx';

const mapStateToProps = (state, ownProps) => {
  const { modelType } = ownProps;
  const {
    selectActiveSectionGroups,
    selectActiveSectionsByGroup,
    selectPendingProposalFieldNames,
    modelFormName,
  } = modelTypesById[modelType];

  const activeSectionGroups = selectActiveSectionGroups(state);
  const activeSectionsByGroup = selectActiveSectionsByGroup(state);
  const pendingFieldNames = selectPendingProposalFieldNames(state);

  return {
    modelType,
    modelFormName,
    sectionGroups: activeSectionGroups,
    sectionsByGroup: activeSectionsByGroup,
    pendingFieldNames,
    pendingProposalCount: pendingFieldNames.length,
  };
};

const mapDispatchToProps = { acceptAllProposedFields, rejectAllProposedFields };

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { modelId, pendingFieldNames, modelFormName } = { ...ownProps, ...stateProps };
  const { acceptAllProposedFields: acceptAll, rejectAllProposedFields: rejectAll } = dispatchProps;
  return {
    ...ownProps,
    ...stateProps,
    onAcceptAllProposals: () => acceptAll(modelId, pendingFieldNames),
    onRejectAllProposals: () => rejectAll(modelId, pendingFieldNames, modelFormName),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withCustomHandleSubmit(ModelPagerSidebar));
